import { useMediaQuery } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

import { BaseModal2 } from '@components/modals/BaseModal2'
import { Breadcrumb } from '@components/shared/Breadcrumb'
import { emotionTheme } from '@styles/theme'
import { Table } from '@components/shared/Table'
import { usePreview } from '@pages/Preview/context'

import { parseUnitDreGrid } from './helpers/parseUnitDreGrid'

import type { UnitDreModalProps } from './types'

import * as apiPreviewManagement from '@services/api/previewManagement'
import * as S from './styles'

export const UnitDreModal = ({ open, unit, onClose }: UnitDreModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)
  const { periodSelectedData } = usePreview()

  const referenceDate = periodSelectedData?.competenceDate

  const { data: detailsData, isLoading } = useQuery({
    queryKey: ['branch-classification-details', unit?.branchCode, referenceDate],
    queryFn: () =>
      apiPreviewManagement.getBranchClassificationDetails({
        branchCode: unit!.branchCode,
        referenceDate: referenceDate!
      }),
    enabled: open && !!unit?.branchCode && !!referenceDate
  })

  const { data } = parseUnitDreGrid(detailsData?.accounts)

  return (
    <BaseModal2
      open={open}
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : '96.5%'}
      heightContainer="auto"
      maxHeightContainer={isMobile ? 'calc(100% - 20px)' : '95%'}
      headerIcon={
        <Breadcrumb
          breadcrumbData={[
            { label: 'Gestão Financeira' },
            { label: 'Prévia' },
            { label: 'Gestão da Prévia' },
            { label: `Classificação das Unidades (Ranking de DRE) - ${unit?.branchDescription ?? ''}` }
          ]}
        />
      }
    >
      <S.SummaryCard>
        <S.SummaryTitle>
          DRE Resumido: <span>{unit?.branchDescription}</span>
        </S.SummaryTitle>
        <S.SummarySubtitle>Visão detalhada das contas contábeis da unidade selecionada</S.SummarySubtitle>
      </S.SummaryCard>

      <Table data={data} isLoading={isLoading} />
    </BaseModal2>
  )
}
